import styled from 'styled-components';

export const Wrapper = styled.div`
  border: solid 1px black;
  padding: 1rem;
`;

export const Title = styled.h2``;

export const Body = styled.div`
  font-family: 'Times New Roman', Times, serif;
  font-size: 1.2rem;
  line-height: 1.4;
`;
